/** Chuỗi màn tự mở tiệm (Pha E, ADR-053; chủ tự đặt mã — ADR-087). */
export const E = {
  chuaCoTiem: 'Chưa có tiệm? Mở tiệm mới',
  coTiemRoi: 'Đã có tiệm — đăng nhập',
  tieuDe: 'Mở tiệm mới',
  goiY: 'Mở xong, bạn sửa dịch vụ, giờ mở cửa và nhân viên cho đúng tiệm.',
  tenTiem: 'Tên tiệm',
  tenTiemGoiY: 'ví dụ: Cửa hàng Hoa Sen',
  // Tên từng ngành: TEN_NGANH trong packages/shared/src/nganh.ts (danh mục một nguồn, ADR-082).
  nganh: 'Cửa hàng thuộc ngành nào?',
  chonNganh: 'Chọn một ngành ở trên để tiếp tục.',
  // Lý do ngắn dưới nút "Tiếp" khi nút đang khoá (theo thứ tự các ô trên màn).
  thieuTenTiem: 'Bạn nhập tên tiệm nhé.',
  thieuTenChu: 'Bạn nhập tên của bạn nhé.',
  thieuSdt: 'Bạn nhập số điện thoại nhé.',
  sdtSai: 'Số điện thoại chưa đúng. Bạn sửa lại nhé.',
  tenChu: 'Tên bạn',
  tiepNut: 'Tiếp',
  quayLai: 'Quay lại',
  // Bước 2 (KH-GĐ2 4.1.5): ba câu chọn mức khởi đầu — app chỉ hiện đúng thứ tiệm cần.
  buoc2TieuDe: 'Tiệm của bạn thế nào?',
  buoc2GoiY: 'Trả lời nhanh để màn hình chỉ hiện đúng thứ bạn cần. Sau này đổi được ở Cấu hình.',
  // Chỉ báo bước (vòng 33 V1): mở tiệm gồm 2 màn.
  buoc: (n: 1 | 2) => `Bước ${n}/2`,
  soNguoi: 'Tiệm có mấy người làm?',
  // Nhãn ngắn: 3 chip một hàng ở khổ 360px không được chạm viền (ui-critic v28).
  motMinh: 'Một mình',
  haiDenNam: '2–5 người',
  trenNam: 'Từ 6 người',
  banGoi: 'Có bán gói nhiều lần hoặc thẻ trả trước không?',
  hoaHong: 'Có trả hoa hồng cho nhân viên không?',
  co: 'Có',
  khong: 'Không',
  // ADR-087: bước cuối có hai ô đặt mã — chủ tiệm tự chọn mã, không bao giờ mất mã "hiện một lần".
  maTieuDe: 'Mã đăng nhập của bạn',
  maGhiGiay: 'Gồm 6 số. Ghi mã ra giấy để khỏi quên.',
  hienMa: 'Hiện mã',
  anMa: 'Ẩn mã',
  datMa: 'Mã 6 số',
  nhapLaiMa: 'Nhập lại mã',
  maLanSau: 'Lần sau bạn đăng nhập bằng số điện thoại và mã này.',
  maPhaiSauSo: 'Mã đăng nhập gồm đúng 6 số.',
  moNut: 'Mở tiệm',
  dangMo: 'Đang mở tiệm…',
  daMoXong: 'Đã mở tiệm. Lần sau vào bằng số điện thoại và mã.',
  daMoChuaVao:
    'Tiệm đã mở rồi nhưng máy chưa vào được. Bạn bấm Đăng nhập, nhập số điện thoại và mã vừa đặt nhé.',
  vaoDangNhap: 'Đăng nhập',
  // 5.4 (ADR-094): ô tích đồng ý Điều khoản dịch vụ — chỉ hiện khi cờ ở máy chủ bật.
  dongYDieuKhoan: 'Tôi đã đọc và đồng ý Điều khoản dịch vụ của SAPA',
  docDieuKhoan: 'Đọc điều khoản',
  canDongYDieuKhoan: 'Bạn tích đồng ý điều khoản để mở tiệm nhé.',
} as const
